import React, { PureComponent } from 'react';
import config from '../../../../../config';

const USD = (val)=> parseFloat(val).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
class BitcoinTradesView extends PureComponent {
  render() {
    const {
      bitcoinTrades,
    } = this.props;

    return (
      <div className="bitcoin-trades-page page">
        <h2>Bitcoin Trades</h2>
        <table>
          <thead>
          <tr>
            <th>Type</th>
            <th>Time</th>
            <th>Buy Price</th>
            <th>Buy Amount</th>
            <th>Balances</th>
          </tr>
          </thead>
          <tbody>
          {bitcoinTrades.map((bitcoinTrade, i) => (
            <tr key={i}>
              <td>{bitcoinTrade.type}</td>
              <td>{(new Date(bitcoinTrade.timestamp)).toLocaleString()}</td>
              <td>{USD(bitcoinTrade.buyPrice)}</td>
              <td>{bitcoinTrade.buyAmount} BTC</td>
              <td>
                {bitcoinTrade.currentBalances.map((balance)=>(
                  <span className="bitcoin-trade-balance" key={balance.account}>
                    {balance.account}: {balance.balance}
                  </span>
                ))}
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default BitcoinTradesView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/BitcoinTrades/BitcoinTrades.view.js